package io.horion.cv.pages.motivation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaDownload
import com.varabyte.kobweb.silk.components.icons.fa.FaPenToSquare
import com.varabyte.kobweb.silk.components.icons.fa.FaTrashCan
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.api.datasource.motivation.ModelLetter
import io.horion.cv.components.Topbar
import io.horion.cv.di.koinGet
import io.horion.cv.styles.CoverLetterStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.UBUNTU
import io.horion.cv.viewModel.LetterViewModel
import kotlinx.browser.window
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Page("/listletter")
@Composable
fun ListLetter() {

        val colorMode by ColorMode.currentState
        val isDark = colorMode.isDark
        Column(
        modifier = Modifier.fillMaxWidth()
            .backgroundColor(if (isDark) Colors.holder else Colors.White)
        ,
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Topbar()
        LetterContent()
    }
}
@OptIn(DelicateApi::class)
@Composable
fun LetterContent() {

    val breakpoint = rememberBreakpoint()
    val isDark = ColorMode.current.isDark
    val ctx = rememberPageContext()

    val letters = mapOf(
        "LETTER_1" to "letterModerne.png",
        "LETTER_2" to "letterSimple.png",
        "LETTER_3" to "letterModerne.png",
        "LETTER_4" to "letterSimple.png"
    )

    // ✅ tailles responsive
    val cardWidth = when {
        breakpoint >= Breakpoint.LG -> 320
        breakpoint >= Breakpoint.MD -> 280
        else -> 240
    }

    val cardHeight = when {
        breakpoint >= Breakpoint.LG -> 450
        breakpoint >= Breakpoint.MD -> 390
        else -> 340
    }

    // ✅ colonnes responsive
    val columns = when {
        breakpoint >= Breakpoint.LG -> 3
        breakpoint >= Breakpoint.MD -> 2
        else -> 1
    }

    val gap = when {
        breakpoint >= Breakpoint.LG -> 35
        breakpoint >= Breakpoint.MD -> 25
        else -> 20
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(
                topBottom = 50.px,
                leftRight = if (breakpoint >= Breakpoint.MD) 20.px else 10.px
            ),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Div(
            attrs = Modifier
                .styleModifier {
                    property("display", "grid")
                    property(
                        "grid-template-columns",
                        "repeat($columns, ${cardWidth}px)"
                    )
                    property("gap", "${gap}px")
                    property("justify-content", "center")
                }
                .toAttrs()
        ) {

            // ✅ CARD "+"
            Box(
                modifier = Modifier
                    .width(cardWidth.px)
                    .height(cardHeight.px)
                    .border(
                        width = 2.px,
                        style = LineStyle.Dashed,
                        color = Colors.GrayLight
                    )
                    .borderRadius(18.px)
                    .backgroundColor(
                        if (isDark)
                            Colors.holder
                        else
                            Colors.White
                    )
                    .cursor(Cursor.Pointer)
                 //   .transition(Transition.of("all", 0.25.s))
                    .onMouseEnter {
                    }
                    .onClick {
                        ctx.router.navigateTo("/motivation")
                    },
                contentAlignment = Alignment.Center
            ) {

                SpanText(
                    "+",
                    modifier = Modifier
                        .fontSize(
                            when {
                                breakpoint >= Breakpoint.MD -> 70.px
                                else -> 56.px
                            }
                        )
                        .fontWeight(FontWeight.Bold)
                        .color(Colors.secondary)
                )
            }

            // ✅ lettres utilisateur
            letters.forEach { letter ->

                LetterCard(
                    isDark = isDark,
                    letter = letter,
                    width = cardWidth,
                    height = cardHeight,
                    breakpoint = breakpoint
                )
            }
        }
    }
}

@Composable
fun LetterCard(
    isDark: Boolean,
    letter: Map.Entry<String, String>,
    width: Int,
    height: Int,
    breakpoint: Breakpoint
) {
    val letterViewModel = koinGet<LetterViewModel>()
    val ctx = rememberPageContext()
    var isHovered by remember { mutableStateOf(false) }
    val showButton = isHovered || breakpoint <= Breakpoint.MD || breakpoint <= Breakpoint.LG

    Box(
        modifier = Modifier
            .width(width.px)
            .height(height.px)
            .cursor(Cursor.Pointer)
            .overflow(Overflow.Visible)
            .onMouseEnter { isHovered = true }
            .onMouseLeave { isHovered = false }
            .onClick {
                ModelLetter.entries
                    .firstOrNull { it.name == letter.key }
                    ?.let { letterViewModel.updateModel(it) }

                ctx.router.navigateTo("/info_letter_page?model=${letter.key}")
            },
        contentAlignment = Alignment.Center
    ) {

        Image(
            src = "/" + letter.value,
            description = "lettre de motivation",
            modifier = CoverLetterStyle
                .toModifier()
                .fillMaxSize()
                .objectFit(ObjectFit.Contain)
                .border(1.px, LineStyle.Solid, Colors.GrayLight)
                .styleModifier {
                    // ✅ légère teinte sombre sur les images en dark mode
                    property("filter", if (isDark) "brightness(0.85)" else "none")
                    property("transition", "filter 300ms ease")
                }
        )

        if (showButton) {

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(bottom = 16.px)
                    .align(Alignment.BottomCenter),
                horizontalArrangement = Arrangement.Center
            ) {

                // ✅ EDITER
                ActionButton(
                    icon = {
                        FaPenToSquare(
                            modifier = Modifier.color(Colors.Black).margin(right = 6.px),
                            size = IconSize.XL
                        )
                    },
                ) {
                    ctx.router.navigateTo("/info_letter_page?model=${letter.key}")
                }

                Spacer()

                // ✅ TELECHARGER
                ActionButton(
                    icon = {
                        FaDownload(
                            modifier = Modifier.color(Colors.Black).margin(right = 6.px),
                            size = IconSize.XL
                        )
                    }
                ) {
                    ctx.router.navigateTo("/")//logique pour telecharger

                }

                Spacer()

                // ✅ SUPPRIMER
                ActionButton(
                    icon = {
                        FaTrashCan(
                            modifier = Modifier.color(Colors.Black).margin(right = 6.px),
                            size = IconSize.XL
                        )
                    },
                ) {
                    ctx.router.navigateTo("/")//logique pour supprimer
                }
            }
        }
    }
}
@Composable
fun Spacer() {
    Box(modifier = Modifier.width(8.px))
}
@Composable
fun ActionButton(
    icon: @Composable () -> Unit,
    onClick: () -> Unit
) {

    Box(
        modifier = Modifier
            .height(38.px)
            .padding(leftRight = 12.px)
//            .backgroundColor(background)
            .borderRadius(10.px)
            .cursor(Cursor.Pointer)
            .onClick { onClick() }
            .opacity(0.90),
        contentAlignment = Alignment.Center
    ) {

        Row(
            modifier = Modifier.padding(leftRight = 10.px),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {

            icon()


        }
    }
}